"use client";

import Slider from "@ant-design/react-slick";
import { NEWS_ITEMS } from "./data/newsItems";
import { T } from "@/lib/i18n/T";
import "./home.css";

const href = (s: string) => (s?.startsWith("url.") ? s.slice(4) : "");

/** "All the latest news" carousel (@ant-design/react-slick, React 19 ready). */
export function NewsCarousel() {
  // Original brand imagery. A couple of brand CDNs hard-block hotlinking
  // (YSL/Prada) — skip those until they route through the backend image proxy.
  const BLOCKED = ["yslbeauty.it", "prada.com"];
  const items = NEWS_ITEMS.filter((it) => {
    const u = href(it.image);
    return u && !BLOCKED.some((d) => u.includes(d));
  });
  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1350, settings: { slidesToShow: 4 } },
      { breakpoint: 1000, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="rb-news csx3-R11">
      <div className="rb-news-inner csx3-C csx3-g-24">
        <div className="rb-news-title csx3-C csx3-g-6">
          <h3><T id="home.news.title" /></h3>
          <p><T id="home.news.body" /></p>
        </div>
        <div className="rb-news-rail">
          <Slider {...settings}>
            {items.map((it, i) => (
              <div key={i}>
                <div className="rb-news-card">
                  <div className="rb-news-card-overlay" />
                  <div className="rb-news-card-img" style={{ backgroundImage: `url(${href(it.image)})` }} />
                  {it.ico}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
